import { CALL_API } from '../../../middleware/api';
import * as API from '../../../services/ApiEndpointsConstants';
import { apiEndpoints } from '../../../services/ApiEndpointsConstants';
import * as ImagesConstants from './ImagesConstants';

export function getAllImagesForProcessing() {
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(API.GET_ALL_IMAGES)}?limit=${
        process.env.REACT_APP_AMOUNT_PENDING_LIMIT
      }`,
      types: [
        ImagesConstants.GET_ALL_IMAGES_FOR_PROCESSING_REQUEST,
        ImagesConstants.GET_ALL_IMAGES_FOR_PROCESSING_SUCCESS,
        ImagesConstants.GET_ALL_IMAGES_FOR_PROCESSING_FAILED
      ]
    }
  };
}

export function saveMultipleImagesStatus(requestData) {
  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'put'
      },
      endpoint: apiEndpoints().entity(API.SAVE_MULTIPLE_IMAGES_STATUS_DATA),
      types: [
        ImagesConstants.SAVE_MULTIPLE_IMAGES_STATUS_REQUEST,
        ImagesConstants.SAVE_MULTIPLE_IMAGES_STATUS_SUCCESS,
        ImagesConstants.SAVE_MULTIPLE_IMAGES_STATUS_FAILED
      ]
    }
  };
}

export function saveMultipleOfflineImagesIDs(requestData) {
  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'put'
      },
      endpoint: apiEndpoints().entity(
        API.SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_DATA
      ),
      types: [
        ImagesConstants.SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_REQUEST,
        ImagesConstants.SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_SUCCESS,
        ImagesConstants.SAVE_MULTIPLE_OFFLINE_IMAGES_IDS_FAILED
      ]
    }
  };
}

export const changeGroupImagesContainerData = (data, deleteIndex = null) => {
  return {
    type: ImagesConstants.CHANGE_GROUP_IMAGES_WORK_DATA,
    data: data,
    deleteIndex: deleteIndex
  };
};

export const changeReservedIdsData = (data) => {
  return {
    type: ImagesConstants.CHANGE_RESERVED_IDS_DATA,
    data: data
  };
};

export const setImageGroupCount = (groupIndex, count) => {
  return {
    type: ImagesConstants.SET_IMAGE_GROUP_COUNT,
    groupIndex: groupIndex,
    count: count
  };
};

export const setImageWorkingIds = (groupIndex, workingIds) => {
  return {
    type: ImagesConstants.SET_IMAGE_WORKING_IDS,
    groupIndex: groupIndex,
    workingIds: workingIds
  };
};
